import { APP_NAME, USER_ROLES } from './app.config';

export default class Utils {
  storage: any;

  constructor() {
    if (!localStorage[APP_NAME]) {
      localStorage[APP_NAME] = JSON.stringify({});
    }
    this.storage = JSON.parse(localStorage[APP_NAME]);
  }

  getStorage(field: string) {
    this.storage = localStorage[APP_NAME]
      ? JSON.parse(localStorage[APP_NAME])
      : {};
    if (this.storage && this.storage[field]) {
      return this.storage[field];
    }
    return null;
  }

  setStorage(field: string, value: any) {
    this.storage = localStorage[APP_NAME]
      ? JSON.parse(localStorage[APP_NAME])
      : {};
    this.storage[field] = value;
    localStorage[APP_NAME] = JSON.stringify(this.storage);
  }

  removeFromStorage(field: string) {
    this.storage = localStorage[APP_NAME]
      ? JSON.parse(localStorage[APP_NAME])
      : {};
    if (this.storage && this.storage[field]) {
      delete this.storage[field];
      localStorage[APP_NAME] = JSON.stringify(this.storage);
    }
  }

  clearAppStorage() {
    delete localStorage["businessOwnerId"]

    if (localStorage[APP_NAME]) {
      delete localStorage[APP_NAME];
    }
  }

  getUserRole(user) {

    if(user.is_lpp_editor)
    {
      return USER_ROLES.LPP_EDITOR;
    }
    else if (user.administrator) {
      return USER_ROLES.ADMINISTRATOR;
    } else if (user.is_business_owner) {
      return USER_ROLES.BUSINESS_OWNER;
    } else if (user.company_administrator.length > 0) {
      return USER_ROLES.COMPANY_ADMIN;
    } else if (user.company_editor.length > 0) {
      return USER_ROLES.COMPANY_EDITOR;
    } else if (user.company_viewer.length > 0) {
      return USER_ROLES.COMPANY_VIEWER;
    }
    return '';
  }

  getUserRoleHomepage(user) {

    const userRole = this.getUserRole(user);
    if(userRole === USER_ROLES.ADMINISTRATOR){
      return "owners"
    }
    if (userRole === USER_ROLES.BUSINESS_OWNER) {
      return 'companies';
    }
    if (userRole === USER_ROLES.COMPANY_ADMIN) {
      return 'company/' + user.company_administrator[0].id;
    }
    if (userRole === USER_ROLES.COMPANY_EDITOR) {
      return 'company/' + user.company_editor[0].id;
    }
    if (userRole === USER_ROLES.COMPANY_VIEWER) {
      return 'playlist/' + user.company_viewer[0].id;
    }
    if(userRole === USER_ROLES.LPP_EDITOR)
    {
      return 'news/'+ user.company_viewer[0].id;
    }
    return '';
  }

  /* User roles utility
  */
  userAnyOfRoles(roles: string[], userRole: string): boolean{
    return roles.includes(userRole)
  }
}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/app.utilities.ts